<template>
  <div class="tag">
    <div class="sales item">
      <span class="num">{{props.currency}}{{props.totalParams.totalAmount}}</span>
      <span class="name">Total Amount</span>
    </div>
    <div class="seller item">
      <span class="num">{{props.currency}}{{props.totalParams.totalPaidAmount}}</span>
      <span class="name">Seller Paid</span>
    </div>
    <div class="publishers item">
      <span class="num">{{props.currency}}{{props.totalParams.totalPendingAmount}}</span>
      <span class="name">Seller Pending</span>
    </div>
    <div class="fees item">
      <span class="num">{{props.currency}}{{ (props.totalParams?.totalPaidPlatformFeeAmount + props.totalParams?.totalDeclinedAmount).toFixed(2) ?? 0}}</span>
      <div class="breakdown">
        <div class="row">
          <span class="label">· Commission</span>
          <span class="value">{{props.currency}}{{props.totalParams.totalPaidPlatformFeeAmount ?? 0}}</span>
        </div>
        <div class="row">
          <span class="label">· Not Applicable</span>
          <span class="value">{{props.currency}}{{props.totalParams.totalDeclinedAmount ?? 0}}</span>
        </div>
      </div>
      <span class="name">ArtemisAds Commission</span>
    </div>
  </div>
</template>
<script setup>
  import { computed } from 'vue';
  const props = defineProps(['totalParams', 'currency']);

  const commissionTotal = computed(() => {
    const paid = Number(props.totalParams?.totalPaidPlatformFeeAmount) || 0;
    const declined = Number(props.totalParams?.totalDeclinedPlatformFeeAmount) || 0;
    return (paid + declined).toFixed(2);
  });
</script>
<style lang="less" scoped>
  .tag {
    display: flex;
    align-items: center;
    margin-top: 16px;
    .item {
      background: #F8F7FC;
      display: flex;
      flex-direction: column;
      padding: 7px 12px;
      color: var(--dark-1);
      text-align: center;
      width: 180px;
      margin-right: 20px;
      border-radius: 12px;
      .num {
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
      }
      .name {
        font-size: 12px;
        color: var(--dark-2);
        font-weight: 600;
        margin-top: 4px;
      }
      .filter {
        font-size: 12px;
        color: var(--dark-3);
      }
    }
    .fees {
      width: 200px;
      .breakdown {
        margin-top: 4px;
        text-align: left;
        .row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          line-height: 18px;
          color: var(--dark-1);
          .label {
            margin-right: 12px;
            white-space: nowrap;
          }
          .value {
            white-space: nowrap;
          }
        }
      }
    }
  }
</style>
